import axios from 'axios';
import { storeUser, getRefreshToken } from './utils/tokens';
import createAuthRefreshInterceptor from 'axios-auth-refresh';

export const defaultUrl = process.env.REACT_APP_API_URL;
axios.defaults.baseURL = defaultUrl;
axios.defaults.withCredentials = true;

// Use interceptor to inject the token to requests
axios.interceptors.request.use(request => {
	if (request.url === 'useraccount/refresh') {
		return request;
	}
	if (getAccessToken()) {
		request.headers['Authorization'] = `Bearer ${getAccessToken()}`;
	}
	return request;
});

export function getAccessToken() {
	return window.sessionStorage.getItem('accessToken');
}

const refreshAuthLogic = failedRequest =>
	axios
		.post('useraccount/refresh', {
			refresh_token: getRefreshToken(),
		})
		.then(tokenRefreshResponse => {
			window.sessionStorage.setItem('token', tokenRefreshResponse.data.token);
			storeUser(tokenRefreshResponse);
			//EventBus.$emit('authChange', true);
			failedRequest.response.config.headers['Authorization'] = 'Bearer ' + tokenRefreshResponse.data.token;
			return Promise.resolve();
		});

createAuthRefreshInterceptor(axios, refreshAuthLogic);
